export const contentData = {
  spanish:{
    layout:{
      title:'Editar Aseguradora',
      navigation:[
        {name:'Catálogos',path:'/catalogs'},
        {name:'Aseguradoras Privadas',path:'/catalogs/insurance_carriers'},
        {name:'Detalles',path:'/catalogs/insurance_carriers/:id'},
        {name:'Editar',path:'/catalogs/insurance_carriers/:id/edit'}
        
      ],
      menu2:[
        {id:0, label:'Mis datos'},
        {id:1, label:'Horario'},
      ],
    },
  }
}